import { Goal, GoalSortingMode, ID, OrderDirection } from '@griply/types';

const isGoalValueEmpty = (goal: Goal, sortMode: GoalSortingMode): boolean => {
  if (sortMode === GoalSortingMode.Impact) {
    return goal.impact == null;
  }
  if (sortMode === GoalSortingMode.StartDate) {
    return !goal.startDate;
  }
  if (sortMode === GoalSortingMode.Deadline) {
    return !goal.deadline;
  }
  if (sortMode === GoalSortingMode.Progress) {
    return !goal.metric?.id;
  }
  if (sortMode === GoalSortingMode.LifeArea) {
    return !goal.lifeAreaId;
  }
  return false;
};

export const getOrderedGoalIds = (
  sortedGoals: Goal[],
  sortMode: GoalSortingMode | undefined,
  direction: OrderDirection,
): ID[] => {
  const effectiveSortMode = sortMode ?? GoalSortingMode.StartDate;
  const withValue: Goal[] = [];
  const withoutValue: Goal[] = [];

  sortedGoals.forEach((goal) => {
    if (isGoalValueEmpty(goal, effectiveSortMode)) {
      withoutValue.push(goal);
      return;
    }
    withValue.push(goal);
  });

  const ordered =
    direction === OrderDirection.Desc ? withValue.slice().reverse() : withValue;

  return [...ordered, ...withoutValue].map(({ id }) => id);
};
